import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function DatenschutzBewerber() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
      <Seo title="Datenschutz für Bewerber – HELIUM Catering" description="Informationen zur Verarbeitung Ihrer Bewerbungsdaten gemäß DSGVO bei HELIUM Catering UG." />
      <h1 className="text-3xl lg:text-4xl font-extrabold">Datenschutz­erklärung für Bewerber</h1>
      <p className="mt-2 text-gray-500">Informationen zur Verarbeitung Ihrer Bewerbungsdaten gemäß Art. 13 DSGVO</p>

      <div className="mt-8 space-y-6 text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-lg font-bold text-gray-900">1. Verantwortlicher</h2>
          <p className="mt-2">HELIUM Catering UG (haftungsbeschränkt). Kontakt für Datenschutzanfragen: <a href="mailto:info@helium-catering.de" className="text-[#D62B3A] underline">info@helium-catering.de</a>.</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">2. Zweck der Verarbeitung</h2>
          <p className="mt-2">Wir verarbeiten Ihre im Rahmen der Bewerbung übermittelten personenbezogenen Daten (u. a. Name, Kontaktdaten, Lebenslauf, Zeugnisse und weitere Anhänge) ausschließlich zur Durchführung des Bewerbungs- und Auswahlverfahrens.</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">3. Rechtsgrundlage</h2>
          <p className="mt-2">Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie zur Anbahnung eines Beschäftigungsverhältnisses (§ 26 Abs. 1 BDSG, Art. 6 Abs. 1 lit. b DSGVO).</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">4. Speicherdauer</h2>
          <p className="mt-2">Wird das Bewerbungsverfahren ohne Einstellung abgeschlossen, werden Ihre Bewerbungsdaten spätestens 6 Monate nach Abschluss des Verfahrens gelöscht, sofern keine gesetzliche Aufbewahrungspflicht entgegensteht oder Sie einer längeren Speicherung ausdrücklich zugestimmt haben. Im Falle einer Einstellung werden die Daten in die Personalakte überführt.</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">5. Speicherung der Anhänge</h2>
          <p className="mt-2">Ihre hochgeladenen Dokumente werden sicher gespeichert und sind ausschließlich für berechtigte Personen im geschützten Admin-Bereich zugänglich.</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">6. Ihre Rechte</h2>
          <p className="mt-2">Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung sowie Datenübertragbarkeit. Eine erteilte Einwilligung können Sie jederzeit widerrufen.</p>
        </section>
        <section>
          <h2 className="text-lg font-bold text-gray-900">7. Löschung Ihrer Daten anfragen</h2>
          <p className="mt-2">Sie können die Löschung Ihrer Bewerbungsdaten jederzeit per E-Mail an <a href="mailto:info@helium-catering.de" className="text-[#D62B3A] underline">info@helium-catering.de</a> anfragen. Wir kommen Ihrer Anfrage unverzüglich nach.</p>
        </section>
      </div>

      <Link to="/karriere" className="inline-block mt-10 text-[#D62B3A] font-semibold">← Zurück zur Karriereseite</Link>
    </div>
  );
}
